/*
 * O converter do member-wannabe-api junta listas com
 * `joinToString(separator = "\n")`, entao `education`, `qualifications` e
 * `about` chegam como uma unica string multilinha. Quem renderiza precisa das
 * linhas separadas.
 */
const toLines = (value?: string): string[] => {
  if (!value) return []

  return value
    .split('\n')
    .map(line => line.trim())
    .filter(Boolean)
}

export { toLines }
